module.exports = __webpack_public_path__ + "83a361466c0d5ee419e9ddb7060c5439.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/sehnsucht.jpg
// module id = 815
// module chunks = 0